// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__192JO","input":"styles_input__1x-vf"};